import React, { FC, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Lookup, Pager, Paging, Selection } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import $createStore from 'utils/create-store-instance';

import { DeleteModal, EditModal } from './components';

type Props = {
  onChangeSelect: (transportId: number) => void;
};

const TransportPage: FC<Props> = ({ onChangeSelect }) => {
  let { id } = useParams<{ id: string }>();

  const transportDataStore: any = useMemo(() => {
    return $createStore(`/v1/transport/${id}`, 'id');
  }, [id]);

  const typeTransport: any = useMemo(() => {
    return $createStore('/v1/Transport/types', 'id');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const [visible, setVisible] = useState<boolean>(false);
  const [openId, setOpenId] = useState<number | null>(null);

  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const refGrid = useRef<DataGrid | null>(null);

  const onSelectionChangedHandler = ({ selectedRowsData }: any) => {
    const data = selectedRowsData[0];
    onChangeSelect(data.id);
  };

  return (
    <div className="container-dev">
      <div className="pr-2 pt-2">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanCreateTransport']}>
            <Button
              width={120}
              text="Добавить"
              type="default"
              onClick={() => {
                setOpenId(null);
                setVisible(true);
              }}
            />
          </ClaimsProvider>
        </AppLayoutTop>
      </div>
      <EditModal
        contractorId={Number(id)}
        visible={visible}
        changeVisible={(show) => setVisible(show)}
        id={openId}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <DeleteModal
        visible={visibleDelete}
        changeVisible={(show) => setVisibleDelete(show)}
        id={openIdDelete}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      {/* <AppCard> */}
      <DataGrid
        dataSource={transportDataStore}
        showBorders={false}
        loadPanel={{
          enabled: true,
          text: 'Загрузка',
        }}
        ref={refGrid}
        remoteOperations={true}
        onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
        onInitNewRow={(e) => (e.data = { name: '', isDeleted: false })}
        //defaultSelectedRowKeys={0}
        hoverStateEnabled
        onSelectionChanged={onSelectionChangedHandler}
        focusedRowEnabled
      >
        <FilterRow visible={true} />
        <Selection mode="single" />
        <Column dataField="transportType" caption="Тип" width={150}>
          <Lookup dataSource={typeTransport} valueExpr="id" displayExpr="name" />
        </Column>
        <Column dataField="model" caption="Марка" />
        <Column dataField="number" caption="Номер" />
        <Column dataField="quantity" caption="Объём / Длина" width={100} />

        <Column dataField="vinCode" caption="Vin" />
        <Column
          dataField="actions"
          caption=""
          width={150}
          cellRender={(data) => (
            <>
              <ClaimsProvider claimsBlock={['CanEditTransport']}>
                <Button
                  icon="edit"
                  type="normal"
                  stylingMode="text"
                  onClick={() => {
                    setOpenId(data.key);
                    setVisible(true);
                  }}
                />
              </ClaimsProvider>
              <ClaimsProvider claimsBlock={['CanDeleteTransport']}>
                <Button
                  icon="trash"
                  type="normal"
                  stylingMode="text"
                  onClick={() => {
                    setOpenIdDelete(data.key);
                    setVisibleDelete(true);
                  }}
                />
              </ClaimsProvider>
            </>
          )}
        />

        <Paging defaultPageSize={15} />
        <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
      </DataGrid>
      {/* </AppCard> */}
    </div>
  );
};

export default TransportPage;
